import classNames from "classnames";
import { PropsWithChildren } from "react"
import { PropsWithClassName } from "shared/props"

import styles from './panel.module.scss';

export interface PanelProps {
	title: string | JSX.Element;
	contentClassName?: string;
}

export const Panel = (props: PropsWithChildren<PanelProps> & PropsWithClassName) => {
	return (
		<div className={classNames(props.className, styles.container)}>
			<h2 className={classNames(styles.header)}>{ props.title }</h2>
			<div className={classNames(styles.content, props.contentClassName)}>{ props.children }</div>
		</div>
	)
}